import DetailsView from "./DetailsView";
import SearchView from "./SearchView";
import { selectIsSearchView, toggleIsDetailsPaneOpen } from "@/features/details/detailsSlice";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { ArrowLeft } from "lucide-react";

const Details = () => {
  const dispatch = useAppDispatch();
  const isSearchView = useAppSelector(selectIsSearchView);

  return (
    <div className="flex flex-col overflow-y-auto border-l border-neutral-300">
      {/* Below md the details pane replaces the chat, whose header holds the only
          close toggle — so it needs its own way back. */}
      <div className="flex items-center gap-2 p-2 border-b border-neutral-300 md:hidden">
        <button
          onClick={() => dispatch(toggleIsDetailsPaneOpen())}
          className="p-2 rounded-md hover:bg-accent"
          aria-label="Close details"
        >
          <ArrowLeft size={20} />
        </button>
        <span className="font-semibold">Details</span>
      </div>
      {isSearchView ? <SearchView/> : <DetailsView />}
    </div>
  );
};

export default Details;
